module.exports = __webpack_public_path__ + "static/004-32c924c06971cad0f973aad33df15834.png";